/**
 * Scrollbar-style track + thumb for complementary slider (updates on scroll / resize).
 */
(function () {
  const initialized = new WeakSet();

  function initComplementaryScrollPagination(root) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll('slider-component.complementary-products__slider').forEach((component) => {
      if (initialized.has(component)) return;

      const slider = component.querySelector('[id^="Slider-"]');
      const thumb = component.querySelector('.complementary-products__scroll-pagination-thumb');
      const bar = component.querySelector('.complementary-products__scroll-pagination');
      const arrows = component.querySelector('.complementary-products__toolbar-arrows');
      if (!slider || !thumb || !bar) return;

      initialized.add(component);

      const track = bar.querySelector('.complementary-products__scroll-pagination-track');
      if (!track) return;

      const updateThumb = () => {
        const { scrollLeft, scrollWidth, clientWidth } = slider;
        if (scrollWidth <= clientWidth + 1) {
          bar.setAttribute('hidden', '');
          arrows.setAttribute('hidden', '');
          return;
        }
        bar.removeAttribute('hidden');
        arrows.removeAttribute('hidden');

        const maxScroll = scrollWidth - clientWidth;
        const thumbWidthPct = Math.max(10, Math.min(100, (clientWidth / scrollWidth) * 100));
        const leftPct = maxScroll <= 0 ? 0 : (scrollLeft / maxScroll) * (100 - thumbWidthPct);

        thumb.style.width = `${thumbWidthPct}%`;
        thumb.style.left = `${leftPct}%`;
      };

      slider.addEventListener('scroll', updateThumb, { passive: true });
      new ResizeObserver(updateThumb).observe(slider);
      updateThumb();
    });
  }

  function scheduleInit() {
    initComplementaryScrollPagination(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  } else {
    scheduleInit();
  }

  document.addEventListener('shopify:section:load', scheduleInit);

  let moTimer;
  const mo = new MutationObserver(() => {
    clearTimeout(moTimer);
    moTimer = setTimeout(scheduleInit, 50);
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
